import { get } from 'lodash';
import {
    BookingPathKeys,
    paths as BookingPaths,
    BOOKING_GA_CATEGORIES,
    basePath,
} from '../Booking/paths';
import { pageName as BookingPageName } from '../Booking/constants';
import { match } from 'react-router';

export const NoRouteMatchErrorText =
    'current route did not match in getPageFromPathname while trying to log an event in the logging.js middleware';

const getPathForKey = pathKey => {
    const pathRoot = BookingPaths[pathKey];
    const isBooking = pathRoot.includes(basePath);

    return isBooking ? `${pathRoot}/:bookingId` : pathRoot;
};

export const allRoutes = [
    ...Object.values(BookingPathKeys).map(pathKey => ({
        path: getPathForKey(pathKey),
        pageName: BookingPageName,
        category: BOOKING_GA_CATEGORIES[pathKey],
    })),
];

export function getPageFromPathname(pathname) {
    return new Promise((resolve, reject) => {
        match(
            {
                location: pathname || window.location.pathname,
                routes: allRoutes,
            },
            (error, redirectLocation, renderProps) => {
                if (renderProps) {
                    const pageName = get(renderProps, 'routes[0].pageName', '');
                    const category = get(renderProps, 'routes[0].category', '');
                    resolve({
                        pageName,
                        category,
                    });
                } else if (error) {
                    reject(error);
                } else {
                    reject(new Error(NoRouteMatchErrorText));
                }
            }
        );
    });
}
